module.exports = __webpack_public_path__ + "img/d769404.png";